import { render } from "./HelpContacts.vue?vue&type=template&id=5e708564&scoped=true"
import script from "./HelpContacts.vue?vue&type=script&lang=js"
export * from "./HelpContacts.vue?vue&type=script&lang=js"

import "./HelpContacts.vue?vue&type=style&index=0&id=5e708564&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e708564"]])

export default __exports__